<template>
  <div :class="msgHolderClass" :style="getComponentStyle" v-if="errorMsgDisplay || msgTextExists">
    <i :class="modulePropsParsed?.iconClass || ''" class="mr10"></i>
    <span class="medium">{{
      errorMsgDisplay?.length > 0
        ? errorMsgDisplay
        : msgText
        ? msgText
        : modulePropsParsed?.msgText
    }}</span>
    <VueLottiePlayer
      v-if="modulePropsParsed?.animation"
      name="confettiAnim"
      width="100%"
      height="100%"
      :animationData="require('../assets/ConfettiOrderSuccessful.json')"
    />
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
import {
  EVENT_IMPRESSION_INLINENOTIFICATION,
  EVENT_CLICK_INLINENOTIFICATION,
} from "../helpers/analyticsEvents";
import Utility from "../helpers/utility"

export default {
  name: "MsgHolder",
  props: {
    msgText: { required: false, default: "" },
    bgColor: { required: false, default: "" },
    borderColor: { required: false, default: "" },
    textColor: { required: false, default: "" },
    iconClass: { required: false, default: "" },
    msgHolderClass: {
      required: false,
      default: "msg-holder mb12 mt12 ml16 mr16",
    },
    moduleProps: { required: false, default: "{}" },
    // @todo : these props will be fetched from moduleProps, when run with load data
  },
  components: {
    VueLottiePlayer: defineAsyncComponent(() => import("vue-lottie-player")),
  },
  data() {
    return {
      modulePropsParsed: {},
      deliveryProps: {
        msgText: "Oops! Something went wrong. Please try again with different location.",
        bgColor: "#FFE8BA",
        borderColor: "#F4D395",
        textColor: "#333",
        iconClass: "hkfi-delivery",
      },
      errorMsgStyles:{
        msgText: "",
        bgColor: "#FFE8BA",
        borderColor: "#F4D395",
        textColor: "#333",
        iconClass: "",
      },
      discountProps: {
        msgText: "You are saving ₹100 with this order",
        bgColor: "#EBFEF3",
        borderColor: "#A1CABB",
        textColor: "#333",
        iconClass: "hkfi-percentage  fs-8",
      },
      rainProps: {
        msgText: "It's raining in your area, this might impact delivery time",
        bgColor: "",
        borderColor: "#909090",
        textColor: "#fff",
        iconClass: "hkfi-rain",
        background: "linear-gradient(265.03deg, #505050 3.65%, #ACACAC 68.21%)",
      },
      impressionProcessed: false,
    };
  },
  mounted() {
    //this.modulePropsParsed = JSON.parse(this.deliveryProps);
    if (this.msgText.length > 0) {
      this.modulePropsParsed = {
        msgText: this.msgText,
        bgColor: this.bgColor,
        borderColor: this.borderColor,
        textColor: this.textColor,
        iconClass: this.iconClass,
      };
    } else if (
      this.moduleProps && JSON.parse(this.moduleProps) &&
      Object.keys(JSON.parse(this.moduleProps))?.length > 0
    ) {
      this.modulePropsParsed = JSON.parse(this.moduleProps);
    } else {
      this.modulePropsParsed = this.errorMsgStyles;
    }
  },
  methods: {
    //
  },
  computed: {
    getComponentStyle() {
      let styleObject = {
        backgroundColor: this.modulePropsParsed.bgColor || "#FFE8BA",
        borderColor: this.modulePropsParsed.borderColor || "#F4D395",
        color: this.modulePropsParsed.textColor || "#333",
      };
      if (this.modulePropsParsed?.background) {
        styleObject.background = this.modulePropsParsed?.background;
      }
      return { ...styleObject };
    },
    msgTextExists() {
      return this.modulePropsParsed?.msgText?.length > 0;
    },
    cartItemsExists() {
      let cartItemsLength = Object.keys(this.$store.state.Cart.items).length;
      if (cartItemsLength > 0 && !this.impressionProcessed) {
        this.impressionProcessed = true;
        EVENT_IMPRESSION_INLINENOTIFICATION();
      }
      return cartItemsLength > 0;
    },
    errorMsgDisplay() {
      if (Utility.isCurrentlyAtUrl("/cart")) {
        return this.$store.state.Cart.displayErrorMsg;
      } else {
        return "";
      }
    },
  },
};
</script>
